<template>
  <a
    class="practice-locale-switch"
    :class="{ 'practice-locale-switch--on': !isHebrew, 'practice-locale-switch--bar': bar }"
    data-cy="practice-locale-switch"
    :href="englishHref"
    :aria-pressed="!isHebrew"
    :aria-label="isHebrew ? 'English' : 'Language: English'"
  >
    EN
  </a>
  <a
    class="practice-locale-switch"
    :class="{ 'practice-locale-switch--on': isHebrew, 'practice-locale-switch--bar': bar }"
    data-cy="practice-locale-he"
    :href="hebrewHref"
    :aria-pressed="isHebrew"
    :aria-label="isHebrew ? 'שפה: עברית' : 'Hebrew'"
  >
    עב
  </a>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import {
  HEBREW_PRACTICE_PATH,
  practiceLocaleSwitchHref,
} from "common/practiceLocale";
import { usePracticeLocale } from "../composables/usePracticeLocale";

defineProps<{
  /** Kept so the app bar can mark this as the bar control. */
  bar?: boolean;
}>();

const route = useRoute();
const { isHebrew } = usePracticeLocale();

const englishHref = computed(() =>
  practiceLocaleSwitchHref("/practice", route.fullPath),
);
const hebrewHref = computed(() =>
  practiceLocaleSwitchHref(HEBREW_PRACTICE_PATH, route.fullPath),
);
</script>

<style scoped>
.practice-locale-switch {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  box-sizing: border-box;
  min-width: 46px;
  height: 32px;
  padding: 0 10px;
  margin-inline: 2px;
  border-radius: 4px;
  background: #fff !important;
  color: #202750 !important;
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.02em;
  text-decoration: none;
  opacity: 1 !important;
}
.practice-locale-switch--on {
  background: #e65100 !important;
  color: #fff !important;
}
</style>
